import { Button } from '@webkom/lego-bricks';
import { spySubmittable } from '~/utils/formSpyUtils';
import type { PressEvent } from '@webkom/lego-bricks';
import type { ComponentProps, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  onPress?: (e: PressEvent) => void;
  className?: string;
  allowPristine?: boolean;
  danger?: boolean;
  disabled?: boolean;
  dark?: boolean;
  size?: ComponentProps<typeof Button>['size'];
};

export const SubmitButton = ({
  children,
  onPress,
  className,
  allowPristine,
  danger = false,
  disabled = false,
  dark = false,
  size,
}: Props) =>
  spySubmittable(
    (submittable) => (
      <Button
        submit
        disabled={!submittable || disabled}
        onPress={onPress}
        className={className}
        danger={danger}
        dark={dark}
        size={size}
      >
        {children}
      </Button>
    ),
    { allowPristine },
  );

export default SubmitButton;
